import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

import { useConfig } from "../context/configContext";

const isAccessTokenValid = (token) => {
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
};

const ProtectedRoute = ({ children }) => {
  const { resetConfig } = useConfig();
  const [authStatus, setAuthStatus] = useState("checking");

  useEffect(() => {
    let isMounted = true;

    const refreshAccessToken = async () => {
      const token = localStorage.getItem("access_token");

      if (isAccessTokenValid(token)) {
        setAuthStatus("authenticated");
        return;
      }

      try {
        const response = await fetch("/api/refresh_token", {
          method: "POST",
          credentials: "include",
        });

        if (!response.ok) {
          throw new Error("Unable to refresh session");
        }

        const data = await response.json();

        if (!data.access_token) {
          throw new Error("Refresh response missing access token");
        }

        localStorage.setItem("access_token", data.access_token);

        if (isMounted) {
          setAuthStatus("authenticated");
        }
      } catch {
        localStorage.removeItem("access_token");
        resetConfig();

        if (isMounted) {
          setAuthStatus("unauthenticated");
        }
      }
    };

    refreshAccessToken();

    return () => {
      isMounted = false;
    };
  }, [resetConfig]);

  if (authStatus === "checking") {
    return null;
  }

  if (authStatus === "unauthenticated") {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
